import React from 'react'
import PropTypes from 'prop-types'
import {
  AddGoalsCopy,
  AddGoalsWrapper,
  DateTitle,
  DateWrapper,
  Error,
  ErrorText,
  InputsWrapper,
  OptionalGoalsSection,
  NumberError,
  NumberTitle,
  NumberWrapper,
  StyledFormInputNumber,
  StyledCalendarInput,
  StyledWarningIcon,
} from './component.styles'
import { StyledHeader } from '../component.styles'
import RequiredGoal from '../RequiredGoal'
import OptionalGoals from '../OptionalGoals'
import {
  classCreationGoalValueName,
  classCreationGoalDateName,
  lessonCompletionGoalValueName,
  lessonCompletionGoalDateName,
} from './data.js'

const AddGoals = ({
  additionalGoalCount,
  modalData,
  values,
  errors,
  touched,
  handleChange,
  handleChangeGoalCount,
}) => {
  const { bodyCopy, choiceContent, header } = modalData || {}
  const [classCreationData, lessonCompletionData] = choiceContent || []

  return (
    <AddGoalsWrapper>
      <StyledHeader>{header}</StyledHeader>
      <AddGoalsCopy>{bodyCopy}</AddGoalsCopy>
      <RequiredGoal
        dataTestId={'class-creation-goal'}
        description={classCreationData.bodyCopy}
        title={classCreationData.h3}
      >
        <InputsWrapper>
          <NumberWrapper>
            <NumberTitle>Number of Classes to Create</NumberTitle>
            <StyledFormInputNumber
              dataTestId={classCreationGoalValueName}
              error={
                touched[classCreationGoalValueName] &&
                errors[classCreationGoalValueName]
              }
              onChange={value => {
                handleChange(classCreationGoalValueName, value)
              }}
              placeholder="Enter number of classes"
              value={values[classCreationGoalValueName]}
            />
            {touched[classCreationGoalValueName] &&
              errors[classCreationGoalValueName] && (
                <NumberError>
                  <StyledWarningIcon />
                  <ErrorText>{errors[classCreationGoalValueName]}</ErrorText>
                </NumberError>
              )}
          </NumberWrapper>
          <DateWrapper>
            <DateTitle>Target Date</DateTitle>
            <StyledCalendarInput
              date={values[classCreationGoalDateName]}
              handleChange={handleChange}
              hasError={
                !!errors[classCreationGoalDateName] &&
                !!touched[classCreationGoalDateName]
              }
              name={classCreationGoalDateName}
              showNeighboringMonth={false}
            />
            {errors[classCreationGoalDateName] &&
              touched[classCreationGoalDateName] && (
                <Error>
                  <StyledWarningIcon />
                  <ErrorText>{errors[classCreationGoalDateName]}</ErrorText>
                </Error>
              )}
          </DateWrapper>
        </InputsWrapper>
      </RequiredGoal>

      <RequiredGoal
        dataTestId={'lesson-completion-goal'}
        description={lessonCompletionData.bodyCopy}
        recommendation={'60%-80% Recommended'}
        title={lessonCompletionData.h3}
      >
        <InputsWrapper>
          <NumberWrapper>
            <NumberTitle>% of Lessons Completed</NumberTitle>
            <StyledFormInputNumber
              dataTestId={lessonCompletionGoalValueName}
              error={
                touched[lessonCompletionGoalValueName] &&
                errors[lessonCompletionGoalValueName]
              }
              onChange={value => {
                handleChange(lessonCompletionGoalValueName, value)
              }}
              placeholder="Enter number"
              value={values[lessonCompletionGoalValueName]}
            />
            {touched[lessonCompletionGoalValueName] &&
              errors[lessonCompletionGoalValueName] && (
                <NumberError>
                  <StyledWarningIcon />
                  <ErrorText>{errors[lessonCompletionGoalValueName]}</ErrorText>
                </NumberError>
              )}
          </NumberWrapper>
          <DateWrapper>
            <DateTitle>Target Date</DateTitle>
            <StyledCalendarInput
              date={values[lessonCompletionGoalDateName]}
              error={errors?.[lessonCompletionGoalDateName]}
              handleChange={handleChange}
              hasError={
                !!errors[lessonCompletionGoalDateName] &&
                !!touched[lessonCompletionGoalDateName]
              }
              name={lessonCompletionGoalDateName}
              showNeighboringMonth={false}
            />
            {errors[lessonCompletionGoalDateName] &&
              touched[lessonCompletionGoalDateName] && (
                <Error>
                  <StyledWarningIcon />
                  <ErrorText>{errors[lessonCompletionGoalDateName]}</ErrorText>
                </Error>
              )}
          </DateWrapper>
        </InputsWrapper>
      </RequiredGoal>

      <OptionalGoalsSection>
        <OptionalGoals
          additionalGoalCount={additionalGoalCount}
          errors={errors}
          handleChange={handleChange}
          handleChangeGoalCount={handleChangeGoalCount}
          touched={touched}
          values={values}
        />
      </OptionalGoalsSection>
    </AddGoalsWrapper>
  )
}

AddGoals.propTypes = {
  additionalGoalCount: PropTypes.number,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleChangeGoalCount: PropTypes.func,
  hasApiError: PropTypes.bool,
  isValid: PropTypes.bool,
  modalData: PropTypes.object,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default AddGoals
